import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import unitKerjaService from "../../../services/ref/unitKerjaService";
import Cookies from "js-cookie";

export const initialState = {
    loading_unit_kerja: false,
    data_unit_kerja: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataUnitKerja = createAsyncThunk('unit_kerja/data',async (data, { rejectWithValue }) => {
    try {
        const response = await unitKerjaService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('unit_kerja/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await unitKerjaService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('unit_kerja/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await unitKerjaService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('unit_kerja/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await unitKerjaService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const unitKerjaSlice = createSlice({
    name: 'unit_kerja',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_unit_kerja = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataUnitKerja.fulfilled, (state, action) => {
                state.loading_unit_kerja = false
                state.data_unit_kerja = action.payload??[]
            })
            .addCase(getDataUnitKerja.pending, (state) => {
                state.loading_unit_kerja = true
            })
            .addCase(getDataUnitKerja.rejected, (state, action) => {
                state.loading_unit_kerja = false
                state.data_unit_kerja = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_unit_kerja = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_unit_kerja = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_unit_kerja = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = unitKerjaSlice.actions

export default unitKerjaSlice.reducer
